import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";

import { C9VALI } from "../../../Validation";
import FormControl from "@mui/material/FormControl";
import { Box } from "react-bootstrap-icons";
import ComponentLoader from "../../../../ComponentLoader";

function C9Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);

  const [documentDescription, setDocumentDescription] = useState("");
  const [realeaseType, setRealeaseType] = useState("");
  const [leadAuthor, setLeadAuthor] = useState("");

  const [documentDescriptionErr, setDocumentDescriptionErr] = useState(false);
  const [realeaseTypeErr, setRealeaseTypeErr] = useState(false);
  const [leadAuthorErr, setLeadAuthorErr] = useState(false);

  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [invis, setInvestigator] = useState();
  const [loader,setLoader] =useState(true);
  const [dropcourse, setDropcourse] = useState([]);
  const [Lovteamleaderrole, setLovteamleaderrole] = useState([]);

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(C9VALI),
  });

  const backs = () => {
    navigate("/C9");
  };

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
      handleLov(tok)
      handleCoursetypes(tok);
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head(" Policy documents");
  }, []);
  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const investigator = localStorage.getItem("loginId");
    setInvestigator(investigator);
  }, []);
  const edit = (item) => {
    console.log(item);
    setDocumentDescription(item.documentDescription);
    setRealeaseType(item.realeaseType);
    setLeadAuthor(item.teamleaderRole);
    setId(item.id);
  };

  const handleClickOpen = () => {
    setOpen(true);
    //  navigate("/Activities")
  };

  const handleClose = () => {
    setOpen(false);
    // setId(0)
  };

  // Lov Team Leader Role
  const handleLov = async (token, TeamleaderRole) => {
    console.log(token);

    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVTYPE}${"TeamleaderRole"}`,
        {
          headers: h,
        }
      );
      console.log(data);
      setLovteamleaderrole(data);
    } catch (error) {
      console.log(error);
    }
  };

  // dropdown
  const handleCoursetypes = async (token, Activities) => {
    console.log(Activities);
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVEAPI}${"RealeaseType"}`,
        { headers: h }
      );
      console.log(data);

      setDropcourse(data);setLoader(false);
    } catch (error) {
      console.log(error);setLoader(false);
    }
  };

  const handleLeavepage = async () => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    console.log(token);
    const d = {
      id,
      DocumentDescription: documentDescription,
      RealeaseType: realeaseType,
      TeamleaderRole: leadAuthor,
      MRSId: state.id,
      investigatorId: parseInt(invis),
      rptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(`${window.BASE}${window.C9SAVE}`, d, {
          headers: h,
        });
        console.log(data);
        setStudentbtn(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/C9");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          // toastError(data.errorMsgs)
        }
        //   setDirect(data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(`${window.BASE}${window.C9EDIT}`, d, {
          headers: h,
        });
        console.log(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/C9");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const formValidateFun=()=>{
    if(!documentDescription){
      documentDescriptionErr(true)
      document.getElementById("documentDescription").focus()
    }else if(!realeaseType){
      setRealeaseTypeErr(true)
      document.getElementById("realeaseType").focus()
    }else if(!leadAuthor){
      setLeadAuthorErr(true)
      document.getElementById("leadAuthor").focus()
    }
    else{
      handleLeavepage()
    }
}

  return (
    <div className="main-container-margin">
       <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/monthyReport">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>(C9). Policy Documents </span>
        </div>
      </div>

      <div className="from-mains">
        <div className="form-control">
          <h5 style={{ margin: 20 }}>C9.Policy documents developed</h5>

          <TextField
            error={documentDescriptionErr}
            id="documentDescription"
            label="Description of the Document (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={documentDescription}
            onChange={(e) => {
              setDocumentDescription(e.target.value);
              setDocumentDescriptionErr(false);
            }}
          />

          <FormControl style={{ width: "48%", margin: 12 }} error={realeaseTypeErr} id="realeaseType">
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Release Type
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={realeaseType}
              label="Course "
              size="small"
              sx={{ width: "100%" }}
              onChange={(e) => {
                setRealeaseType(e.target.value);
                setRealeaseTypeErr(false);
              }}
            >
              {dropcourse?.map((row) => {
                return <MenuItem value={row.lovName}>{row.lovName}</MenuItem>;
              })}
            </Select>
          </FormControl>

          {/* <TextField
            error={leadAuthorErr}
            id="leadAuthor"
            label="Lead Author"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={leadAuthor}
            onChange={(e) => {
                setLeadAuthor(e.target.value)
                setLeadAuthorErr(false)
              }}
          /> */}

          <FormControl style={{ width: "48%", margin: 12 }} error={leadAuthorErr} id="leadAuthor">
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Role
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={leadAuthor}
              label="Course "
              size="small"
              sx={{ width: "100%" }}
              onChange={(e) => {
                setLeadAuthor(e.target.value);
                setLeadAuthorErr(false);
              }}
            >
              {Lovteamleaderrole?.map((row) => {
                return <MenuItem value={row.lovName}>{row.lovName}</MenuItem>;
              })}
            </Select>
          </FormControl>

          <div className="from-last">
            <button
              type="submit"
              style={{ backgroundColor: "#008CBA", height: "20px",padding:"5px 30px 28px 26px",borderRadius:"3px",color:"#fff" }}
              onClick={backs}
            >
              Back
            </button>
            <button type="submit" className="sbmit-buttons" onClick={formValidateFun} style={{paddingTop:"5px"}}>
            Save
            </button>
          </div>

          <TableBody>
            {Array.isArray(Studentbtn) &&
              Studentbtn.map((row) => (
                <TableRow key={row.Natureofcoaching}>
                  <TableCell align="right">{row.natureofcoaching}</TableCell>
                  <TableCell align="right">{row.noofclassesoffered}</TableCell>
                  <TableCell align="right">{row.fellowshipName}</TableCell>
                  <TableCell align="right">{row.noOfStudent}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </div>
      </div>
    </div>
  );
}

export default C9Inside;
